import i18n from 'i18next';

export function localization() {
  return {
    body: {
      emptyDataSourceMessage: i18n.t('no_records'),
    },
    header: {
      actions: i18n.t('actions'),
    },
    pagination: {
      labelRowsSelect: i18n.t('rows'),
      labelDisplayedRows: i18n.t('{from}-{to} od {count}'),
    },
  };
}
